export default __webpack_public_path__ + "static/media/churchillOpen.070871ee.jpg";